'use client';
import React from 'react';
import Chip from '@pezeshk-book/ui-kit/chip';
import EyeIcon from '@icons-components/eye-icon';
import dictionaryParser from '@utils/helpers/dictionary-parser';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const PostHits = ({ hits }: { hits: any }) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { posts } = getDictionary(lang);

  return (
    <Chip
      color={'tertiary'}
      startAdornment={<EyeIcon/>}
      value={dictionaryParser({ content: posts.details.hits, variables: [{ hits: hits }] })}/>
  );
};

export default PostHits;
